import { html } from '../../lib/html'

function byWidth(a, b) {
  return a.width - b.width
}

const defaultBackgroundColor = '#e3e3e3'

export function renderResponsiveImage(image, sizes, priority) {
  if (!image?.crops?.length) {
    return ''
  }
  const selectedFormat = image.selectedFormats?.[0] ?? image.originalFormat ?? '5:4'
  const [w, h] = selectedFormat.split(':')

  const crops = image.crops.filter((crop) => crop.format === selectedFormat).sort(byWidth)
  const fallbackImage = crops[0]

  const backgroundColor = image.averageColor?.hex ?? defaultBackgroundColor
  const altTextColor = image.averageColor?.isDark ? '#fff' : '#000'
  return html`<img
    src="${fallbackImage?.url}"
    srcset="${crops.map((crop) => `${crop.url} ${crop.width}w`).join(', ')}"
    alt="${image.description}"
    width="${w * 1000}"
    height="${h * 1000}"
    ${sizes ? `sizes="${sizes}"` : ''}
    style="background-color:${backgroundColor}; color: ${altTextColor}"
    ${priority ? 'fetchpriority="high"' : 'loading="lazy"'}
  />`
}
